export default __webpack_public_path__ + "static/heat_exchanger_b.a078a372ead61598f0093d5f4d2a9453.svg";